import { render, staticRenderFns } from "./workProposalAlert.vue?vue&type=template&id=49d27d46&scoped=true"
import script from "./workProposalAlert.vue?vue&type=script&lang=js"
export * from "./workProposalAlert.vue?vue&type=script&lang=js"
import style0 from "./workProposalAlert.vue?vue&type=style&index=0&id=49d27d46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d27d46",
  null
  
)

export default component.exports